export interface TenantRelacionadoPedido {
    tenantId: number;
    code: string;
    name: string;
    rol: string;
}

export interface CopiarPedidoRelacionadoDestino {
    tenantId: number;
    tenantCode: string;
    nroFormulario: number | null;
    ok: boolean;
    error: string | null;
}

export interface CopiarPedidoRelacionadosResult<TPedido = unknown> {
    nroFormularioOrigen: number;
    pedidoOrigen: TPedido | null;
    destinos: CopiarPedidoRelacionadoDestino[];
}

const texto = (value: unknown): string => String(value ?? '').trim();

const numeroONull = (value: unknown): number | null => {
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
};

export function mapTenantRelacionadoPedido(raw: unknown): TenantRelacionadoPedido | null {
    if (!raw || typeof raw !== 'object') return null;
    const row = raw as Record<string, unknown>;
    const tenantId = numeroONull(row.tenantId ?? row.TenantId);
    if (tenantId == null || tenantId <= 0) return null;
    return {
        tenantId,
        code: texto(row.code ?? row.Code),
        name: texto(row.name ?? row.Name) || texto(row.code ?? row.Code),
        rol: texto(row.rol ?? row.Rol),
    };
}

export function mapCopiarPedidoRelacionadosResult<TPedido = unknown>(
    data: unknown,
): CopiarPedidoRelacionadosResult<TPedido> {
    const root = (data && typeof data === 'object' ? data : {}) as Record<string, unknown>;
    const destinosRaw = root.destinos ?? root.Destinos;
    const destinos = (Array.isArray(destinosRaw) ? destinosRaw : [])
        .map((item) => {
            if (!item || typeof item !== 'object') return null;
            const row = item as Record<string, unknown>;
            const tenantId = numeroONull(row.tenantId ?? row.TenantId) ?? 0;
            return {
                tenantId,
                tenantCode: texto(row.tenantCode ?? row.TenantCode ?? row.code ?? row.Code),
                nroFormulario: numeroONull(row.nroFormulario ?? row.NroFormulario),
                ok: row.ok === true || row.Ok === true,
                error: texto(row.error ?? row.Error) || null,
            } satisfies CopiarPedidoRelacionadoDestino;
        })
        .filter((item): item is CopiarPedidoRelacionadoDestino => item != null);

    const pedidoRaw = root.pedidoOrigen ?? root.PedidoOrigen;
    return {
        nroFormularioOrigen: numeroONull(root.nroFormularioOrigen ?? root.NroFormularioOrigen) ?? 0,
        pedidoOrigen: pedidoRaw && typeof pedidoRaw === 'object' ? (pedidoRaw as TPedido) : null,
        destinos,
    };
}
